import React, { useState, useEffect } from 'react';
import KenCard from '../../global_components/KenCard';
import KenGrid from '../../global_components/KenGrid';
import KenDialog from '../../global_components/KenDialogBox';
import KenSelectWrap from '../../global_components/KenSelect';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import feedback from './FeedBack.json';
import './Feedback.css';
import moment from 'moment';
import {
  getFacultyAndFacilty,
  filterListSessionGetData,
  filterSessionAddData,
  filterSessionDeleteData,
} from '../../Utils/apiServices';
import {
  Grid,
  Button,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@material-ui/core';
import KenButton from '../../global_components/KenButton';

const FeedbackGrid = ({ SelectedID, value, CourseID, SessionData }) => {
  const [showData, setshowData] = useState(true);
  var now = new Date();
  console.log('nownownownownownow', moment(now).format('YYYY-MM-DD'));
  const [data, setData] = useState([]);
  const [Columns, setColumns] = useState([]);
  const [options, setOptions] = useState([]);
  const [addMode, setAddMode] = useState(false);

  const [editMode, setEditMode] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [masterDialog, setMasterDialog] = useState(false);
  const [sessionId, setSessionId] = useState('');
  const [sessionFeedbackSetupId, setsessionFeedbackSetupId] = useState('');

  const [filterParamters, setfilterParamters] = useState('');

  const createFeedback = (id) => {
    setSessionId(id);
    setOptions([]);
    setEditMode(false);
    setViewMode(false);
    setMasterDialog(true);
  };
  const editFeedback = (id, data) => {
    setSessionId(id);
    setsessionFeedbackSetupId(data.sessionFeedbackSetupId);
    setOptions(data.feedBackParameters.split(';'));
    setEditMode(false);
    setViewMode(true);
    setMasterDialog(true);
  };
  const deleteFeedback = (itemsId, data) => {
    const deleteData = {
      Operation: 'Delete',
      SessionFeedbackSetup: [
        {
          sessionFeedbackSetupId: data.sessionFeedbackSetupId,
        },
      ],
    };
    filterSessionDeleteData(deleteData)
      .then((res) => {
        if (res.SessionFeedbackSetup[0].success === 'true') {
          setAddMode(true);
        }
      })
      .catch((error) => {
        console.log('deleteData', error);
      });
  };
  useEffect(() => {
    if (value === 0) {
      setshowData(true);
      console.log('SessionDataSessionData', SessionData);
      // filterListSessionGetData()
      //   .then((res) => {
      //     // const filterData = [];
      //     // res.data.map((items) => {
      //     //   console.log(
      //     //     'itemsitemsitemsitems',
      //     //     moment(items.startDate).format('YYYY-MM-DD')
      //     //   );
      //     //   filterData.push({
      //     //     Name: items.sessionName,
      //     //     'Session no': items.id,
      //     //     Time: moment(items.startDate).format('HH:mm'),
      //     //     Date: moment(items.startDate).format('YYYY-MM-DD'),
      //     //     Action: (
      //     //       <>
      //     //         {items.SessionFeedBackSetup === null ? (
      //     //           <KenButton
      //     //             onClick={() => createFeedback(items.id)}
      //     //             variant="primary"
      //     //             label={<Typography>Create</Typography>}
      //     //           />
      //     //         ) : moment(items.startDate).format('YYYY-MM-DD') >
      //     //           moment(now).format('YYYY-MM-DD') ? (
      //     //           <>
      //     //             <KenButton
      //     //               onClick={() =>
      //     //                 editFeedback(items.id, items.SessionFeedBackSetup)
      //     //               }
      //     //               variant="primary"
      //     //               label={<Typography> view|edit</Typography>}
      //     //             />
      //     //             <KenButton
      //     //               onClick={() =>
      //     //                 deleteFeedback(items.id, items.SessionFeedBackSetup)
      //     //               }
      //     //               variant="primary"
      //     //               label={<Typography> Delete</Typography>}
      //     //               style={{ marginLeft: '10px' }}
      //     //             />
      //     //           </>
      //     //         ) : (
      //     //           <KenButton
      //     //             onClick={() =>
      //     //               editFeedback(items.id, items.SessionFeedBackSetup)
      //     //             }
      //     //             variant="primary"
      //     //             label={<Typography> view|edit</Typography>}
      //     //           />
      //     //         )}
      //     //       </>
      //     //     ),
      //     //   });
      //     // });
      //     // setData(filterData);
      //   })
      //   .catch((error) => {});

      const feedbackColums = [];
      feedback.feedbackColumns.map((colums) => {
        feedbackColums.push({
          Header: colums.name,
          accessor: colums.name,
          disableGlobalFilter: false,
        });
      });
      setColumns(feedbackColums);
    }
    if (value === 1) {
      setshowData(true);
      const feedbackData = [];
      feedback.feedbackSubjectdetails.map((feedback) => {
        feedbackData.push({
          'Subject Name': feedback['Subject Name'],
          Section: feedback['Section'],
          'Faculty Name': feedback['Faculty Name'],
          Action: (
            <>
              {feedback.Action === 'create' ? (
                <KenButton
                  onClick={() => createFeedback(feedback.id)}
                  variant="primary"
                  label={<Typography>Create</Typography>}
                />
              ) : (
                <KenButton
                  onClick={() => editFeedback(feedback.id)}
                  variant="primary"
                  label={<Typography> view|edit</Typography>}
                />
              )}
            </>
          ),
        });
      });
      setData(feedbackData);

      const feedbackColums = [];
      feedback.feedbackSubjectColumns.map((colums) => {
        feedbackColums.push({
          Header: colums.name,
          accessor: colums.name,
          disableGlobalFilter: false,
        });
      });
      setColumns(feedbackColums);
    }
  }, [CourseID, SelectedID, value, addMode]);
  useEffect(() => {
    getFacultyAndFacilty()
      .then((res) => {
        var feedbackparamters = [];
        res.FeedBackParameter.map((feedback) => {
          feedbackparamters.push({
            label: feedback.label,
            value: feedback.value,
          });
        });
        setfilterParamters(feedbackparamters);
      })
      .catch((error) => {
        console.log('errorerrorerrorerror', error);
      });
  }, []);

  const handleAddOptions = () => {
    console.log('sessionIdsessionId', sessionFeedbackSetupId);
    console.log('handleAddOptions', options.join(';'));
    const filterAddData = {
      Operation: 'Create',
      SessionFeedbackSetup: [
        {
          sessionFeedbackSetupId: sessionFeedbackSetupId
            ? sessionFeedbackSetupId
            : '',
          sessionId: sessionId,
          feedBackParameters: options.join(';'),
        },
      ],
    };
    filterSessionAddData(filterAddData).then((res) => {
      if (res.SessionFeedbackSetup[0].success === 'true') {
        setAddMode(true);
        setMasterDialog(false);
      }
      console.log('resresres', res.SessionFeedbackSetup[0].success);
    });
  };
  const handleInputChange = (e) => {
    setOptions(e.target.value);
  };
  useEffect(() => {
    if (editMode) {
      setViewMode(false);
    }
  }, [editMode]);
  console.log('setDatasetData', editMode);
  return (
    <div>
      <KenDialog
        title={
          viewMode === false ? (
            editMode === true ? (
              <Typography variant="h6">Edit feedback</Typography>
            ) : (
              <Typography variant="h6">Add feedback</Typography>
            )
          ) : (
            <Typography variant="h6">View Feedback</Typography>
          )
        }
        open={masterDialog}
        handleClose={() => setMasterDialog(false)}
        negativeButtonClick={() => {
          setMasterDialog(false);
        }}
        positiveButtonClick={() => {
          handleAddOptions();
        }}
        maxWidth={'md'}
        positiveButtonText={'Save'}
        negativeButtonText="Cancel"
        viewMode={viewMode}
        setEditMode={setEditMode}
        dividers
      >
        <Grid container spacing={2} className="custom-select-box">
          <Grid item xs={6}>
            {viewMode === true && (
              <>
                <p style={{ fontSize: '1rem', fontWeight: '400' }}>
                  Parameters:
                </p>
                <List component="nav" aria-label="contacts">
                  {options.length > 0 &&
                    options.map((option) => {
                      return (
                        <>
                          <ListItem className="optionList">
                            <ListItemText primary={option} />
                          </ListItem>
                        </>
                      );
                    })}
                </List>
              </>
            )}

            {viewMode === false && editMode === false && (
              <KenSelectWrap
                name="options"
                label="Parameters"
                value={options}
                options={filterParamters}
                onChange={(e) => handleInputChange(e)}
                multiple={true}
                required
              />
            )}
            {editMode === true && (
              <KenSelectWrap
                name="options"
                label="Parameters"
                value={options}
                options={filterParamters}
                onChange={(e) => handleInputChange(e)}
                multiple={true}
                required
              />
            )}
          </Grid>
          {viewMode === false && (
            <Grid item xs={6}>
              <p style={{ fontSize: '12px', fontWeight: '400' }}>
                Selected Parameters:
              </p>
              <List component="nav" aria-label="contacts">
                {options.length > 0 &&
                  options.map((option) => {
                    return (
                      <>
                        <ListItem className="optionList">
                          <ListItemIcon>
                            <FiberManualRecordIcon />
                          </ListItemIcon>
                          <ListItemText primary={option} />
                        </ListItem>
                      </>
                    );
                  })}
              </List>
            </Grid>
          )}
        </Grid>
      </KenDialog>
      {showData && (
        <div className="feedbackMainDiv">
          <KenCard elevation={0}>
            <KenGrid
              columns={Columns}
              data={data}
              pagination={{ disabled: true }}
              toolbarDisabled={true}
            />
          </KenCard>
        </div>
      )}
    </div>
  );
};

export default FeedbackGrid;
